import {locationSchema} from '../schema/location.schema';

export const LOCATIONQUERY = `query ( $meta: RequestEntityMetaIn!) {
    findLocations(meta: $meta) {
                ${locationSchema}
           }
       }
   `;
